import { render } from "./App.vue?vue&type=template&id=c8f7ab2c"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=c8f7ab2c&lang=css"

import exportComponent from "/var/www/vhosts/derbyweb.dev/todo.derbyweb.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__